export default {
  inserted: el => {
    let previousY = 0;
    // let animationTimingFunction = "cubic-bezier(0, 0.01, 0, 1)";
    let animationTimingFunction = "cubic-bezier(0, 0.38, 0.62, 1)";
    let animationDuration = "1s";
    let animationDelay = 0;
    let inverseDelay = 0;

    if (el.dataset.delay) {
      let originalDelay = el.dataset.delay.split("/", 2);
      let order = +originalDelay[0];
      let count = +originalDelay[1];

      animationDelay = Math.floor(Math.abs((count / order - count) / 4) * 1000);
      let inverseOrder = Math.abs(count - order) + 1;
      inverseDelay = Math.floor(Math.abs((count / inverseOrder - count) / 4) * 1000);
    }

    function setAnimation(target, animationName, animationDelay) {
      target.style.WebkitAnimation = `${animationName} ${animationDuration} ${animationTimingFunction} ${animationDelay}ms forwards`;
      target.style.animation = `${animationName} ${animationDuration} ${animationTimingFunction} ${animationDelay}ms forwards`;
    }

    function handleIntersect(entries) {
      entries.forEach(entry => {
        let currentY = entry.boundingClientRect.y;
        let currentRatio = entry.intersectionRatio;
        let isIntersecting = entry.isIntersecting;
        let realTarget = entry.target.firstChild;

        if (currentY < previousY) {
          if (isIntersecting) {
            setAnimation(realTarget, "fadeInUp", animationDelay);
          } else if (!isIntersecting && currentRatio === 0) {
            setAnimation(realTarget, "fadeOutUp", animationDelay);
          }
        } else {
          if (isIntersecting) {
            setAnimation(realTarget, "fadeInDown", inverseDelay);
          } else if (!isIntersecting && currentRatio === 0) {
            setAnimation(realTarget, "fadeOutDown", inverseDelay);
          }
        }

        previousY = currentY;
      });
    }

    function createObserver() {
      let fadeContainer = document.createElement("div");
      fadeContainer.classList.add("fade-container");
      el.parentNode.appendChild(fadeContainer);

      let fadeTarget = document.createElement("div");
      fadeTarget.classList.add("fade-target");

      fadeContainer.appendChild(fadeTarget);
      fadeTarget.appendChild(el);

      const options = {
        root: null,
        threshold: "0"
      };
      const observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(fadeContainer);
    }

    if (window["IntersectionObserver"] && window.innerWidth >= 1200) {
      createObserver();
    }
  }
};
